import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Path } from '~/routes/constants';

export const useIsPatientPath = (): boolean => {
  const location = useLocation();
  const { pathname } = location;

  return useMemo(() => pathname.includes(Path.MAUD_PATIENTS), [pathname]);
};
